// import { useState } from "react";
// import axios from "axios";

// export default function useApiProgress() {
//   const [progress, setProgress] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);

//   const callApi = async (config) => {
//     try {
//       setProgress(0);
//       setIsLoading(true);

//       const response = await axios({
//         ...config,
//         onUploadProgress: (p) => {
//           if (p.total) {
//             setProgress(Math.round((p.loaded * 100) / p.total));
//           }
//         },
//         onDownloadProgress: (p) => {
//           if (p.total) {
//             setProgress(Math.round((p.loaded * 100) / p.total));
//           }
//         },
//       });

//       return response.data;
//     } catch (err) {
//       throw err;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return { progress, isLoading, callApi };
// }

import { useState } from "react";
import axios from "axios";

export default function useApiProgress() {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const callApi = async (config) => {
    try {
      setProgress(0);
      setIsLoading(true);

      const response = await axios({
        ...config,
        onDownloadProgress: (e) => {
          if (e.total) {
            setProgress(Math.round((e.loaded / e.total) * 100));
          }
        },
      });

      return response.data;
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { progress, isLoading, callApi };
}